<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [array]="aniosDisponibles"
    [typeFilter]="Filtros.YEAR"
    [name]="'filtros.anio' | translate"
    (eventClick)="anioChange($event)"
    [click]="false"
  />
  <app-filters filtros
    [array]="mesesDisponibles"
    [typeFilter]="Filtros.MOUNTH"
    [name]="'filtros.mes' | translate"
    (eventClick)="mesChange($event);"
    [click]="false"
  />

  <div contenido class="workSpaceTab">
    <div class="zonaChips" [ngClass]="{'w3-disabled':reloadElements || download}">

      <div class="togElement">
        <mat-slide-toggle labelPosition="before" id="tendencia" [(ngModel)]="tendenciaA" #tendencia>
          <div style="width: 13vw; font-weight: 600;">{{'riesgo-credito.reporte.tendencia' | translate}}</div> 
        </mat-slide-toggle>
      </div>
      <div class="togElement">
          <mat-slide-toggle labelPosition="before" id="matriz" [(ngModel)]="matrizA" #matriz>
            <div style="width: 13vw; font-weight: 600;">{{'riesgo-credito.reporte.matriz' | translate}}</div> 
          </mat-slide-toggle>
        </div>
      @if (matrizA) {
        <div class="togElement">
          <mat-slide-toggle labelPosition="before" id="tabla2" [(ngModel)]="tabla2" #tabla2>
            <div style="width: 13vw; padding-left: 1vw;">{{'riesgo-credito.reporte.cuentas' | translate}}</div> 
          </mat-slide-toggle>
        </div>

        <div class="togElement" (click)="s1=!s1; s2=false" style="cursor: pointer;">
          <span style="color: black; padding-left: 1vw;">{{'riesgo-credito.reporte.sucursales' | translate}}</span>
          <mat-icon class="iconoMen w3-button"> {{s1?'expand_less':'expand_more'}}</mat-icon>
        </div>
        <div class="collapse-container" [class.expanded]="s1">
          @for (item of sucursales; track item; let i = $index) {
            <div class="togElement">
              <mat-slide-toggle labelPosition="before" id="sucursal{{i}}" [(ngModel)]="item.select" (change)="Funtion_matrizTransicion()">
                <div style="width: 13vw; padding-left: 1vw;">{{item.Nombre_Sucursal}}</div> 
              </mat-slide-toggle>
            </div>
          }
        </div>
        <mat-divider style="width: 4vw; margin-bottom: 1vh; border-color: black; margin-left: 1vw;"></mat-divider>
      }

      <div class="togElement">
        <mat-slide-toggle labelPosition="before" id="cosechas" [(ngModel)]="cosechasA" #cosechas>
          <div style="width: 13vw; font-weight: 600;">{{'riesgo-credito.reporte.cosechas' | translate}}</div> 
        </mat-slide-toggle>
      </div>

      @if (cosechasA) {
        <div class="togElement">
          <mat-slide-toggle labelPosition="before" id="cosechas" [(ngModel)]="tablaCosechas" #cosechasTabla>
            <div style="width: 13vw; padding-left: 1vw;">{{'riesgo-credito.reporte.grafica' | translate}}</div> 
          </mat-slide-toggle>
        </div>
        <div class="togElement">
          <div class="labels" style="width: 13vw; float: left; padding-left: 1vw;">{{'riesgo-credito.reporte.metrica' | translate}}</div>
          <mat-button-toggle-group class="toggles" [(ngModel)]="porPorcent" (change)="getDataCosechas()">
            <mat-button-toggle [value]="true" class="labels">{{'riesgo-credito.reporte.porcentaje' | translate}}</mat-button-toggle>
            <mat-button-toggle [value]="false" class="labels">{{'riesgo-credito.reporte.saldos' | translate}}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="togElement" (click)="s2=!s2; s1=false" style="cursor: pointer;">
          <span style="color: black; padding-left: 1vw;">{{'riesgo-credito.reporte.sucursales' | translate}} </span>
          <mat-icon class="iconoMen w3-button"> {{s2?'expand_less':'expand_more'}}</mat-icon>
        </div>

        <div class="collapse-container" [class.expanded]="s2">
          @for (item of sucursales2; track item; let i = $index) {
            <div class="togElement">
              <mat-slide-toggle labelPosition="before" id="sucursal{{i}}" [(ngModel)]="item.select" (change)="getCosechas()">
                <div style="width: 13vw; padding-left: 1vw;">{{item.Nombre_Sucursal}}</div> 
              </mat-slide-toggle>
            </div>
          }
        </div>
        <mat-divider style="width: 4vw; margin-bottom: 1vh; border-color: black; margin-left: 1vw;"></mat-divider>
      }

      <div class="togElement">
        <mat-slide-toggle labelPosition="before" id="st_introduccion" [(ngModel)]="concentracionA" #concentracion>
          <div style="width: 13vw; font-weight: 600;">{{'riesgo-credito.reporte.concentracion' | translate}}</div> 
        </mat-slide-toggle>
      </div>

      <div class="togElement">
        <mat-slide-toggle labelPosition="before" id="st_introduccion" [(ngModel)]="deudoresA" #deudores>
          <div style="width: 13vw; font-weight: 600;">{{'riesgo-credito.reporte.mayores-deudores' | translate}}</div> 
        </mat-slide-toggle>
      </div>

      @if (deudoresA) {
        <div class="togElement">
          <div class="labels" style="width: 13vw; float: left; padding-left: 1vw;">{{'riesgo-credito.reporte.imprimir' | translate}}</div>
          <mat-button-toggle-group class="toggles" [(ngModel)]="numDeudores" (change)="getDeudores()">
            <mat-button-toggle [value]="10" class="labels">{{'riesgo-credito.reporte.deudores-1' | translate}}</mat-button-toggle>
            <mat-button-toggle [value]="20" class="labels">{{'riesgo-credito.reporte.deudores-2' | translate}}</mat-button-toggle>
            <mat-button-toggle [value]="30" class="labels">{{'riesgo-credito.reporte.deudores-3' | translate}}</mat-button-toggle>
            <mat-button-toggle [value]="40" class="labels">{{'riesgo-credito.reporte.deudores-4' | translate}}</mat-button-toggle>
            <mat-button-toggle [value]="50" class="labels">{{'riesgo-credito.reporte.deudores-5' | translate}}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      }

      <div class="togElement">
        <mat-slide-toggle labelPosition="before" id="st_introduccion" [(ngModel)]="conclusionesA" #conclusiones>
          <div style="width: 13vw; font-weight: 600;">{{'riesgo-credito.reporte.conclusion' | translate}}</div> 
        </mat-slide-toggle>
      </div>
      
    </div>
    <div class="zonaVisualizacion">
      @if (!download && !reloadElements) {
        <div class="preview-background">
          @if (tendenciaA) {
            <section class="page">
              <div class="pageName">
                {{'riesgo-credito.reporte.tendencia' | translate}}
              </div>
              <div class="zonaGraf">
                @if (multi.length !== 0) {
                  <app-graficador 
                    [etiquetas]="true"
                    [data]="multi"
                    [labels]="etiquetas"
                    [type]="tipoSelecTendencia"
                    [axisX]="xAxisLabel"
                    [axisY]="yAxisLabel"
                    [zona]="1"
                    [colors]="colorScheme"
                    [formatEtiquetas]="true"
                    [changeLabel]="false"
                    [legend]="{enabled: true, position: 'bottom'}"
                  ></app-graficador>
                }
              </div>
              <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                <mat-label>{{'riesgo-credito.reporte.analisis' | translate}}</mat-label>
                <textarea matInput
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="500"
                  [(ngModel)]="textEd2Tendencia">
                </textarea>
              </mat-form-field>
            </section>
          }
          <br>
          @if (matrizA) {
            <section class="page">
              <div class="pageName">
                {{'riesgo-credito.reporte.matriz' | translate}}
              </div>
              @for (tabla of dataMatrices1; track tabla; let i = $index) {
                <h2 style="margin-top: 2vh;">{{nombreSucursales[i]}}</h2>
                <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                  <mat-label>{{'riesgo-credito.reporte.analisis' | translate}}</mat-label>
                  <textarea matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="500"
                    [(ngModel)]="textEd1Matriz[i]">
                  </textarea>
                </mat-form-field>
                <div class="w3-row">
                  <div class=" w3-scroll" style="width: 98%; padding: 2vh;">
                    <table class="w3-table">
                      <thead>
                        <tr class="w3-center">
                          <th></th>
                          @for (r of tabla; track $index) {
                            <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{r[0]}}</th>
                          }               
                        </tr>
                      </thead>
                      <tbody>
                        @for (d of tabla; track d; let i = $index) {
                          <tr class="w3-table-trtd w3-center borderInf">
                            @for (n of d; track n; let j = $index) {
                              @if(j===0){
                                <td class="w3-table-titleLow borderAllLow">{{n}}</td>
                              } @else if (j == d.length-1 || i == tabla.length-1) {
                                <td class="borderAllLow">{{formatearnormal(n.toFixed(2))}}</td>
                              }@else {
                                @if (n.value != 0) {
                                  <td class="borderAllLow" [class]="PintarCelda(j-1,i)">{{formatearnormal(n.value)}}</td>
                                }           
                                @else {<td class="borderAllLow" [class]="PintarCelda(j-1,i)"></td>}
                              }                      
                            }                      
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="zonatarjeta">
                    <div class="w3-row w3-white w3-margin-topEstadistico" style="height: 12.3vh;">
                      <div class="w3-row textLeft">
                        <span class="w3-total-textoEstadistico" style="color: #8B8E93;">{{'riesgo-credito.matriz.tarj1' | translate}}</span>
                      </div>
                      <div class="iconoCifra">
                        <div class="w3-row">
                          <span class="w3-total-cantidadRiesgos w3-balance-verde" style="margin-top: 0px !important;"> {{formatearnormal(total_abajodiagonal[i])}} </span>
                        </div>
                      </div>
                      <div class="w3-row textLeft" style="vertical-align: bottom;">
                        <span class="w3-subtituloMeta"> {{dateReport.format('MMMYYYY')}} </span>
                      </div>
                    </div>
                  </div>
                  <div class="zonatarjeta">
                    <div class="w3-row w3-white w3-margin-topEstadistico" style="height: 12.3vh;">
                      <div class="w3-row textLeft">
                        <span class="w3-total-textoEstadistico" style="color: #8B8E93;">{{'riesgo-credito.matriz.tarj2' | translate}}</span>
                      </div>
                      <div class="iconoCifra">
                        <div class="w3-row">
                          <span class="w3-total-cantidadRiesgos w3-balance-azul" style="margin-top: 0px !important;"> {{formatearnormal(total_diagonal[i])}} </span>
                        </div>
                      </div>
                      <div class="w3-row textLeft" style="vertical-align: bottom;">
                        <span class="w3-subtituloMeta"> {{dateReport.format('MMMYYYY')}} </span>
                      </div>
                    </div>
                  </div>
                  <div class="zonatarjeta">
                    <div class="w3-row w3-white w3-margin-topEstadistico" style="height: 12.3vh;">
                      <div class="w3-row textLeft">
                        <span class="w3-total-textoEstadistico" style="color: #8B8E93;">{{'riesgo-credito.matriz.tarj3' | translate}}</span>
                      </div>
                      <div class="iconoCifra">
                        <div class="w3-row">
                          <span class="w3-total-cantidadRiesgos  w3-balance-naranja" style="margin-top: 0px !important;"> {{formatearnormal(total_arribadiagonal[i])}} </span>
                        </div>
                      </div>
                      <div class="w3-row textLeft" style="vertical-align: bottom;">
                        <span class="w3-subtituloMeta"> {{dateReport.format('MMMYYYY')}} </span>
                      </div>
                    </div>
                  </div>
                <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                  <mat-label>{{'riesgo-credito.reporte.analisis' | translate}}</mat-label>
                  <textarea matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="500"
                    [(ngModel)]="textEd2Matriz[i]">
                  </textarea>
                </mat-form-field>
                @if(tabla2){
                  <div class="w3-scroll" style="width: 98%;">
                    <table class="w3-table">
                      <thead>
                        <tr class="w3-center">
                          <th></th>
                          @for (r of dataMatrices2[i]; track $index) {
                            <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{r[0]}}</th>
                          }               
                        </tr>
                      </thead>
                      <tbody>
                        @for (d of dataMatrices2[i]; track d; let i = $index) {
                          <tr class="w3-table-trtd w3-center borderInf">
                            @for (n of d; track n; let j = $index) {
                              @if(j===0){
                                <td class="w3-table-titleLow borderAllLow" style="max-width: 1vw !important;">{{n}}</td>
                              } @else {
                                @if (n != 0) {<td class="borderAllLow">{{formatearnormal(n)}}</td>}           
                                @else {<td class="borderAllLow"></td>}
                              }                        
                            }                      
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  <div class="zonatarjeta">
                    <div class="w3-row w3-white w3-margin-topEstadistico" style="height: 12.3vh;">
                      <div class="w3-row textLeft">
                        <span class="w3-total-textoEstadistico" style="color: #8B8E93;">{{'riesgo-credito.matriz.tarj4' | translate}}</span>
                      </div>
                      <div class="iconoCifra">
                        <div class="w3-row">
                          <span class="w3-total-cantidadRiesgos w3-balance-verde" style="margin-top: 0px !important;"> {{formatearnormal(total_abajodiagonalII[i])}} </span>
                        </div>
                      </div>
                      <div class="w3-row textLeft" style="vertical-align: bottom;">
                        <span class="w3-subtituloMeta"> {{dateReport.format('MMMYYYY')}} </span>
                      </div>
                    </div>
                  </div>
                  <div class="zonatarjeta">
                    <div class="w3-row w3-white w3-margin-topEstadistico" style="height: 12.3vh;">
                      <div class="w3-row textLeft">
                        <span class="w3-total-textoEstadistico" style="color: #8B8E93;">{{'riesgo-credito.matriz.tarj5' | translate}}</span>
                      </div>
                      <div class="iconoCifra">
                        <div class="w3-row">
                          <span class="w3-total-cantidadRiesgos w3-balance-azul" style="margin-top: 0px !important;"> {{formatearnormal(total_diagonalII[i])}} </span>
                        </div>
                      </div>
                      <div class="w3-row textLeft" style="vertical-align: bottom;">
                        <span class="w3-subtituloMeta"> {{dateReport.format('MMMYYYY')}} </span>
                      </div>
                    </div>
                  </div>
                  <div class="zonatarjeta">
                    <div class="w3-row w3-white w3-margin-topEstadistico" style="height: 12.3vh;">
                      <div class="w3-row textLeft">
                        <span class="w3-total-textoEstadistico" style="color: #8B8E93;">{{'riesgo-credito.matriz.tarj6' | translate}}</span>
                      </div>
                      <div class="iconoCifra">
                        <div class="w3-row">
                          <span class="w3-total-cantidadRiesgos  w3-balance-naranja" style="margin-top: 0px !important;"> {{formatearnormal(total_arribadiagonalII[i])}} </span>
                        </div>
                      </div>
                      <div class="w3-row textLeft" style="vertical-align: bottom;">
                        <span class="w3-subtituloMeta"> {{dateReport.format('MMMYYYY')}} </span>
                      </div>
                    </div>
                  </div>
                  <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                    <mat-label>{{'riesgo-credito.reporte.analisis' | translate}}</mat-label>
                    <textarea matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="5"
                      cdkAutosizeMaxRows="500"
                      [(ngModel)]="textEd3Matriz[i]">
                    </textarea>
                  </mat-form-field>
                }
              }
            </section>
          }
          <br>
          @if (cosechasA) {
            <section class="page">
              <div class="pageName">
                {{'riesgo-credito.reporte.cosechas' | translate}}
              </div>
              @for (tab of dataSource; track tab; let i = $index) {
                <h2 style="margin-top: 2vh;">{{nombreSucursales2[i]}}</h2>
                <div class="w3-scroll w3-table-all">
                    <table class="w3-table">
                      <thead>
                        <tr class="w3-table-titleLow w3-center">
                          <th class="w3-border-right-balance">{{'riesgo-credito.cosechas.tit1' | translate}}</th>
                          <th class="w3-border-right-balance">{{'riesgo-credito.cosechas.tit2' | translate}}</th>
                          @for(nombreMes of nombres_mes; track nombreMes; let i = $index){
                            <th class="w3-border-right-balance">{{nombres_mes[nombres_mes.length-i-1]}}</th>
                          }
                        </tr>
                      </thead>
                      @for(element of tab; track element; let i = $index){
                        <tbody>
                          <tr class="w3-table-trtd w3-center borderInf">
                            <td class="borderAllLow marginsH alinLeft"> {{element.cosecha}} </td>
                            <td class="borderAllLow marginsH  w3-right-align"> {{formatearnormal(element.montocolocado)}} </td>
                            @for (mes of element.meses; track mes; let j = $index) {
                              <td style="width: 7%;" [class]="pintar(i,11-j)" [ngStyle]="{'color': colorText(mes)}" class="borderAllLow marginsH">
                                @if (pintarPorcent(mes) && porPorcent) {
                                  <span style="font-weight: bold;" class="w3-button">{{mes}} %</span>
                                }
                                @if (pintarPorcent(mes) && !porPorcent) {
                                  <span class="w3-button">{{formatearnormal(mes)}} </span>
                                }
                              </td>
                            }                          
                          </tr>
                        </tbody>
                      }
                    </table>
                </div>
                @if (tablaCosechas) {
                  <div class="zonaGraf">
                    <app-graficador 
                      [etiquetas]="false"
                      [data]="dataBarrasMor[i]"
                      [labels]="etiquetasCosechas"
                      [type]="tipoSelecCosecha"
                      [axisX]="xAxisLabel"
                      [axisY]="yAxisLabel"
                      [zona]="30+i"
                      [colors]="colorScheme"
                      [formatEtiquetas]="true"
                      [changeLabel]="false"
                      [legend]="{enabled: true, position: 'bottom'}"
                    ></app-graficador>
                  </div>
                }
                <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                  <mat-label>{{'riesgo-credito.reporte.analisis-editor' | translate}}</mat-label>
                  <textarea matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="500"
                    [(ngModel)]="textEd1Cosechas[i]">
                  </textarea>
                </mat-form-field>
              }
              <br>
            </section>
          }
          <br>
          @if (concentracionA) {
            <section class="page">
              <div class="pageName">
                {{'riesgo-credito.reporte.concentracion' | translate}}
              </div>
              <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                <mat-label>{{'riesgo-credito.reporte.analisis' | translate}}</mat-label>
                <textarea matInput
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="500"
                  [(ngModel)]="textEd1Concentracion">
                </textarea>
              </mat-form-field>
              <div class="zonaGraf">
                @if (multi.length !== 0) {
                  <app-graficador 
                    [etiquetas]="false"
                    [data]="dataConcentracion"
                    [labels]="etiquetasConcentracion"
                    [type]="typeConcentracion"
                    [axisX]="'Porcentaje'"
                    [axisY]="['Monto', '%']"
                    [zona]="50"
                    [colors]="colorScheme"
                    [formatEtiquetas]="true"
                    [legend]="{enabled: true, position: 'bottom'}"
                    [animations]="true"
                    [speedAnimations]="500"
                  ></app-graficador>
                }
              </div>
            </section>
          }
          <br>
          @if (deudoresA) {
            <section class="page">
              <div class="pageName">
                {{'riesgo-credito.reporte.mayores-deudores' | translate}}
              </div>
              <div class="zonaGraf">
                @if (multi.length !== 0) {
                  <app-graficador 
                    [etiquetas]="true"
                    [data]="grafDeudores"
                    [labels]="etiquetasDeudores"
                    [type]="typeDeudores"
                    [axisX]="'Porcentaje'"
                    [axisY]="['Nombre socio']"
                    [zona]="60"
                    [colors]="colorScheme"
                    [formatEtiquetas]="false"
                    [legend]="{enabled: true, position: 'right'}"
                  ></app-graficador>
                }
              </div>
              <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                <mat-label>{{'riesgo-credito.reporte.analisis' | translate}}</mat-label>
                <textarea matInput
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="500"
                  [(ngModel)]="textEd1Deudores">
                </textarea>
              </mat-form-field>
              <div class="w3-row">
                <div class=" w3-scroll" style="width: 98%; padding: 2vh;">
                  <table class="w3-table">
                    <thead>
                      <tr class="w3-center">
                        @for (r of encabezadosTabla; track r; let enc = $index) {
                          @if (enc!==2) {
                            <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{r}}</th>
                          }
                        }               
                      </tr>
                    </thead>
                    <tbody>
                      @for (d of tablaDeudores; track d; let i = $index) {
                        <tr class="w3-table-trtd w3-center borderInf">
                          <td class="borderAllLow">{{i+1}}</td>
                          <td class="borderAllLow">{{d.clave}}</td>
                          <td class="borderAllLow w3-balance-bluep">{{formatearnormal(d.value)}}</td>
                          <td class="borderAllLow">{{d.porcentaje}} %</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          }
          <br>
          @if (conclusionesA){
            <section class="page">
              <div class="pageName">
                {{'riesgo-credito.reporte.conclusiones' | translate}}
              </div>
              <mat-form-field appearance="outline" class="zonaTexto" color="warn">
                <mat-label>{{'riesgo-credito.reporte.analisis-editor' | translate}}</mat-label>
                <textarea matInput
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="500"
                  [(ngModel)]="textEd1Conclusiones">
                </textarea>
              </mat-form-field>
            </section>
          }
        </div>
      }@else {
        <div class="preview-background">
          <div class="page">
            <ngx-skeleton-loader count="5" [theme]="{ 
              'border-radius': '10px',
              height: '2vh',
              width: '50vw',
            }" />
            <ngx-skeleton-loader [theme]="{ 
              'border-radius': '15px',
              height: '36vh',
              width: '58vw',
            }" />
          </div>
        </div>
      }
    </div>
    <!-- Botón flotante -->
    <div [ngClass]="{'w3-disabled': download || reloadElements}">
      <button mat-fab class="fab textoOverFlow" (click)="generarPDF()" [matTooltip]="'riesgo-credito.reporte.descargar' | translate">
        <mat-icon>download</mat-icon>
      </button>
    </div>
  </div>
</app-esqueleto-tableros>